import {NavLink, Outlet} from "react-router-dom";
import styles from "./AdminLayout.module.css";
import {useQuestions} from "../../contexts/QuestionsContext";

// Д1 (§3): панелът живее ПОД глобалния AppLayout (Ред 1 остава). Лявата колона
// са разделите по одобрената скица; съдържанието е <Outlet/>. В Етап 1 се
// показват само наличните раздели — Етап 2 добавя останалите.
const SECTIONS = [
    {to: '/admin', label: 'Табло', end: true},
    // И2: „Въпроси" е втори по ред — това е разделът, който иска бърза реакция.
    {to: '/admin/questions', label: 'Въпроси', badge: 'questions'},
    {to: '/admin/users', label: 'Потребители'},
    {to: '/admin/data', label: 'Данни'},
    {to: '/admin/nomenclature', label: 'Номенклатури'},
    {to: '/admin/links', label: 'Линкове'},
    {to: '/admin/activity', label: 'Активност'},
    {to: '/admin/system', label: 'Система'},
];

export const AdminLayout = () => {
    const {unanswered} = useQuestions();

    return (
        <div className={styles.wrap}>
            <aside className={styles.side}>
                {SECTIONS.map(s => (
                    <NavLink key={s.to} to={s.to} end={s.end}
                             className={({isActive}) =>
                                 `${styles.item} ${isActive ? styles.active : ''}`}>
                        {s.label}
                        {s.badge === 'questions' && unanswered > 0 && (
                            <span className="badge bg-danger ms-2">{unanswered}</span>
                        )}
                    </NavLink>
                ))}
            </aside>
            <section className={styles.content}>
                <Outlet/>
            </section>
        </div>
    );
};
